import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { apm } from '@elastic/apm-rum'

const ApmRouteTracker = () => {
  const location = useLocation()

  useEffect(() => {
    if (!apm) {
      // eslint-disable-next-line no-console
      console.warn('No active apm found.')
      return undefined
    }

    const transaction = apm.startTransaction(location.pathname, 'route-change')

    return () => {
      if (transaction) {
        transaction.end()
      }
    }
  }, [location.pathname])

  return null
}

export default ApmRouteTracker
